"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var TableItem_1 = __importDefault(require("./TableItem"));
function Table(_a) {
    var viewType = _a.viewType, items = _a.items, isInModerationMode = _a.isInModerationMode, angularJsDependencies = _a.angularJsDependencies, handleSelectJobRow = _a.handleSelectJobRow, selectedJobRows = _a.selectedJobRows, domain = _a.domain, automationListsPermission = _a.automationListsPermission;
    var handleRowClick = function (jobItem) {
        var _a, _b;
        if (!isInModerationMode)
            return;
        var checked = selectedJobRows.includes(((_a = jobItem.ad) === null || _a === void 0 ? void 0 : _a.id) || '');
        handleSelectJobRow(((_b = jobItem.ad) === null || _b === void 0 ? void 0 : _b.id) || '', !checked);
    };
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('search-item-list', isInModerationMode && 'in-moderation-mode') },
        react_1.default.createElement("div", null, items.map(function (jobItem, index) {
            var _a, _b;
            return (react_1.default.createElement("div", { className: (0, clsx_1.default)('search-item-container search-item-grid-style', {
                    'search-item-grid-style': viewType === 'grid',
                    'search-item-list-style': viewType === 'list',
                }), style: {
                    backgroundColor: selectedJobRows.includes(((_a = jobItem.ad) === null || _a === void 0 ? void 0 : _a.id) || '') ? '#F3E5F5' : '#FFFFFF',
                    cursor: isInModerationMode ? 'copy' : 'default',
                }, key: "".concat((_b = jobItem.ad) === null || _b === void 0 ? void 0 : _b.id).concat(viewType).concat(index), onClick: function () {
                    handleRowClick(jobItem);
                } },
                react_1.default.createElement(TableItem_1.default, { key: index, job: jobItem, angularJsDependencies: angularJsDependencies, isInModerationMode: isInModerationMode, imagesMetadata: jobItem.imagesMetadataArray || [], videosMetadata: jobItem.videosMetadataArray || [], viewType: viewType, domain: domain, automationListsPermission: automationListsPermission })));
        }))));
}
exports.default = Table;
